import { useDispatch, useSelector } from "react-redux";
import { itactPageFetchActionCreator, itactPageLoadActionCreator } from "../../../store/actions/itact";
import { itactLoadingPageSelector, itactPageSelector } from "../../../store/selectors/itact.selector";
import { IOrderFilter, IPageRequest } from "../../../types/api.types";
import { IPageResourceLoader } from "../../../types/hook.types";
import { IOrder } from "../../../types/order.types";
import { mapPageResponseToPageRequest } from "../../../utils/mapping";

export type IItactPageLoader = IPageResourceLoader<IOrder, IOrderFilter>

export const useItactPageLoader = (): IItactPageLoader => {
    const dispatch = useDispatch();

    const page = useSelector(itactPageSelector);
    const loadingPage = useSelector(itactLoadingPageSelector);
    const loadPage = (pageRequest: IPageRequest<IOrderFilter>) => dispatch(itactPageLoadActionCreator(pageRequest));
    const refresh = () => {
        const pageRequest = page ? mapPageResponseToPageRequest(page) : {
            pageNumber: 0,
            filter: {}
        };

        return dispatch(itactPageFetchActionCreator(pageRequest));
    };

    return {
        resource: page,
        loadingResource: loadingPage,
        loadResource: loadPage,
        refresh
    };
};
